<template>
  <div id="myCloud">
      <span id="mcTitle" v-text="mCText"></span>
      <div id="mcTable">
          <ul id="mcTh" class="cle">
              <li :class="[items.class,'fl']" v-show="index!==2?index!==3?true:false:false" v-for="(items,index) in title"
               :key="index" v-text="items.text" :title="items.text"></li>
          </ul>
          <ul v-for="(item,index) in setList" :key="index" class="cle">
              <li :class="[title[0].class,'fl']" v-text="item.name+(item.isShare?'('+ShareDevice+')':'')" :title="item.name+(item.isShare?'('+ShareDevice+')':'')"></li>
              <li :class="[title[1].class,'fl']" v-text="item.id" :title="item.id"></li>
              <li :class="[title[2].class,'fl']" v-show="false" v-text="item.type" :title="item.type"></li>
              <li :class="[title[3].class,'fl']" v-show="false" v-text="item.ip" :title="item.ip"></li>
              <li :class="[title[4].class,'fl']">
                  <img v-if="item.id!==''" :src="item.online?Online:Downline" style="width:18px;height:18px;margin-top:3px;">
              </li>
              <li :class="[title[5].class,'fl']">
                  <img v-if="item.access" :src="Access" @click="access($event,item.id,item.name,item.password,item.weekdays,item.periods,item.isShare,item.isHs,item.online,item.share,item.encodeKey)" style="width:18px;height:18px;margin-top:3px;cursor:pointer;">
              </li>
              <li :class="[title[6].class,'fl']">
                  <img v-if="item.change" :src="Change" @click="change($event,item.id,item.name,item.isShare,item.isHs,item.password,item.channel)" style="width:18px;height:18px;margin-top:3px;cursor:pointer;">
              </li>
              <li :class="[title[7].class,'fl']">
                  <img v-if="item.share && item.isHs !== 3" :src="Share" @click="share($event,item.id,item.isShare,item.name,item.isHs)" style="width:18px;height:18px;margin-top:3px;cursor:pointer;">
                  <button type="button" v-if="item.shareStatus && item.isHs !== 3" :disabled="item.shareState===1" :title="shareStatus[item.shareState]" v-text="shareStatus[item.shareState]" @click="setStatus(item.id,item.user,item.name,item.accountID,item.isHs)"></button>
              </li>
              <li :class="[title[8].class,'fl']">
                  <img v-if="item.del" :src="Del" @click="del($event,item.id,item.accountID,item.isHs)" style="width:18px;height:18px;margin-top:3px;cursor:pointer;">
              </li>
          </ul>
      </div>
      <div style="width:100%;height:30px;" class="cle">
          <Page :nowPage="nowPage" :allPage="allPage" :showNum="showNum" v-on:getPage="getPage" class="fr"></Page>
      </div>
  </div>
</template>
<script>
import share from '../assets/js/share'
import Page from './Page'
import cloud from '../assets/js/cloud'
export default {
    name:'MyDevice',
    props:['myDevice','ocx'],
    components:{
        Page:Page
    },
    data(){
        return{
            mCText:'',
            title:[
                // {text:'',class:'title-2'},
                // {text:'',class:'title-3'},
                // {text:'',class:'title-2'},
                // {text:'',class:'title-3'},
                {text:'',class:'title-6'},
                {text:'',class:'title-6'},
                {text:'',class:'title-2'},
                {text:'',class:'title-6'},

                {text:'',class:'title-1'},
                {text:'',class:'title-1'},
                {text:'',class:'title-1'},
                {text:'',class:'title-1'},
                {text:'',class:'title-1'},
            ],
            Share: './static/img/share.png',
            ShareDevice:'',
            Change: './static/img/change.png',
            notShare:'',
            notEdit:'',
            notTime:'',
            Access: './static/img/access.png',
            Del:'./static/img/del.png',
            Online:'./static/img/online.png',
            Downline:'./static/img/downline.png',
            setList:[],
            nowPage:1,
            allPage:1,
            showNum:10,
            wkAs:{
                'id':'',
                'name':'',
                'pwd':'',
                'share':''
            },
            pro:'http://',
            isHs:0,
            pwd:'',
            IPPort:'',
            contP:'',
            shareStatus:[
                this.lanNow.lan['K196_Stay'],
                this.lanNow.lan['K181_Share'],
                this.lanNow.lan['K195_Ignored']
            ],
            httpsTest:false
        }
    },
    mounted:function(){
        this.lang();
        var arr=[];
        for(var i=0;i<10;i++){
            arr.push($.extend({},cloud.listObj));
        };
        this.setList=arr;
    },
    methods:{
        share:function(_that,id,isShare,name,isHs){
            this.isHs=isHs;
            if(isShare){
                alert(this.lanNow.lan['K151_NotShare']);
                return false;
            };
            if(id===''){
                return false;
            };
            this.$emit('shareBom',{id:id,name:name,isHs:isHs});
        },
        setStatus:function(id,user,name,accountID,isHs){
            var obj={
                id:id,
                user:user,
                name:name,
                accountID:accountID,
                isHs:isHs
            };
            this.$emit('reRemind',false);
            this.$emit('remindGet',[obj]);
            this.$emit('remindSH',true);
        },
        change:function(_that,id,name,isChange,isHs,upo,channel){
            this.isHs=isHs;
            if(id===''){
                return false;
            };
            this.$emit("editBom",{ele:_that,id:id,name:name,isChange:isChange,upo:upo,num:channel,isHs:isHs});
        },
        del:function(_that,id,isShare,isHs){
            if(id===''){
                return false;
            };
            if(!confirm(this.lanNow.lan['K047_ConDelete'])){
                return false;
            };
            this.ajaxH.repeat=function(){
                if (isHs === 3) {
                    this.delDeviceById(_that, id);
                } else {
                    this.delAfter(_that,id,isShare,isHs);
                }
            }.bind(this);
            this.$emit('refresh');
        },
        delAfter:function(_that,id,isShare,isHs){
            this.isHs=isHs;
            if(isShare){
                var cancelStr=share.exitShareSet({
                    sessionId:this.ajaxH.session,
                    oem:this.baseData.oem,
                    accountId:isShare,
                    account:localStorage.getItem('userName'),
                    id:id,
                    isHs:isHs
                });
                var data=this.ajaxSet({
                    ip:this.cloudName,
                    type:'auth/user',
                    xml:cancelStr
                });
                this.delResultCancle(data.data);
            }else{
                var delStr=cloud.delDevice({
                    sessionId:this.ajaxH.session,
                    oem:this.baseData.oem,
                    id:id,
                    isHs:isHs
                });
                var data=this.ajaxSet({
                    ip:this.cloudName,
                    type:'auth/user',
                    xml:delStr
                });
                this.delResult(data.data);
            };
        },
        delDeviceById: function (_that,id) {
            var params = {
                "header": {
                    "client": {
                        "app": "",
                        "id": "",
                        "oem": this.baseData.oem,
                        "type": 3
                    },
                    "command": "device-delete-by-id",
                    "flag": "tdkcloud",
                    "session": this.ajaxH.session,
                    "user-data": "",
                    "version": "v1.20"
                },
                "content": {
                    "duid": id
                }
            }
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                cType: 'json',
                xml:JSON.stringify(params)
            });
            this.delResult(data.data, true);
        },
        delResult:function(data, isById){
            if (isById) {
                var result=(data.header || {}).result;
            } else {
                var result=$(data).find('header').find('result').text()-0;
            }
            var key = this.promptInfo(result);
            if(result===0){
                alert(this.lanNow.lan["K142_delSuccess"]);
                this.$emit('refresh');
            }else{
                alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
            };
        },
        delResultCancle:function(data){
            var result=$(data).find('result').text();
            if(result === "0"){
                alert(this.lanNow.lan['K142_delSuccess']);
                this.$emit('refresh');
            }else{
                var key = this.promptInfo(result);
                alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
            };
        },
        access:function(_that,id,name,pwd,weekdays,periods,isShare,isHs,online,shares,encodeKey){
            this.isHs=isHs;
            this.pwd=pwd;
            this.encodeKey=encodeKey;
            this.httpsTest=false;
            if(periods!==0){
                var time=new Date();
                var day=time.getDay();
                var hour=time.getHours;
                var min=time.getMinutes();
                var sec=time.getSeconds();
                var s=hour*60*60+min*60+sec;
                var week=weekdays.split(',');
                var per=periods.split(',');
                if(week.indexOf(day+'')>-1){
                    var isTime=false;
                    for(var i=0;i<per.length;i++){
                        var peri=per[i].split('-');
                        var st=peri[0].split(':');
                        var sts=st[0]*60*60+st[1]*60+st*1;
                        var et=peri[1].split(':');
                        var ets=et[0]*60*60+et[1]*60+et*1;
                        if(s>=sts&&s<=ets){
                            isTime=true;
                            break;
                        };
                    };
                    if(isTime){
                        alert(this.lanNow.lan['K153_NotTime']);
                        return false;
                    };
                }else{
                    alert(this.lanNow.lan['K153_NotTime']);
                    return false;
                };
            };
            if(id===''){
                return false;
            };
            if(shares){

            };
            var str=share.deviceSharec({
                sessionId:this.ajaxH.session,
                oem:this.baseData.oem,
                id:id,
                isHs: this.isHs
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:JSON.stringify(str),
                cType:'json'
            });
            this.$emit("loadMsg",true);
            //   1.    IGetSupportP2P()，返回值为1表示插件支持IOT穿透功能
            //   2.    ICloudAddMapPortEx("云ID"， chn) : chn == 0,表示穿透34567，用于预览 ；chn == 2，表示穿透80,用于跳转到登录网页
            // this.$nextTick(function(){
                if(this.browserDetect() !== 'IE')
                {
                    this.wkAs.id = id;
                    this.wkAs.name = name;
                    this.wkAs.pwd = pwd;
                    this.wkAs.encodeKey = encodeKey;
                    this.wkAs.share = isShare;
                    if(this.socket.set.readyState===1){
                        this.pro='http://';
                        this.socketObj.set[116]=function(res){
                            if(this.isHs){
                                this.cf_MyDeviceP2PHs(res[0]);
                            }else{
                                this.cf_MyDeviceP2P(res[0]);
                            };
                        }.bind(this);
                        if(this.isHs){
                            var idType = '0';
                            if (this.isHs === 3) {
                                idType = '1'
                            }
                            this.socket.set.send(this.jsonStr(116,[id,2,idType]));//非IE浏览器端口穿透华视云
                        }else{
                            this.socket.set.send(this.jsonStr(116,[id,2,'1']));//非IE浏览器端口穿透
                        };
                    }else{
                        this.$emit("loadMsg",false);
                    };
                    return false;
                };
                if(this.isHs){
                    this.pwd=JSON.parse(this.pwd);
                };
                setTimeout(function(){
                    var ocx=this.ocx;
                    try {
                        var test=this.ocx.IGetSupportP2P()-0;
                        if(test===0){
                            this.$emit("loadMsg",false);
                            if(confirm(this.lanNow.lan['K160_NoSupport'])){
                                window.open(this.baseData['Plug-in']);
                            };
                            return false;
                        };
                    } catch (error) {
                        this.$emit("loadMsg",false);
                        if(confirm(this.lanNow.lan['K149_plugIn'])){
                            window.open(this.baseData['Plug-in']);
                        };
                    };
                    if(this.isHs){
                        this.pro='http://';
                        var po=ocx.ICloudAddMapPort(id, 2, 0)-0;
                        if (po <= 0){
                            this.$emit("loadMsg",false);
                            alert(this.lanNow.lan['K174_Fail']);
                            this.$emit('refresh');
                            return false;
                        };
                        var content = '<?xml version="1.0" encoding="utf-8"?>' +
                            '<envelope>' +
                            '<header>' +
                            '<security>username</security>' +
                            '<username>' +this.pwd.user+ '</username>' +
                            '<password>' +this.pwd.pwd+ '</password>' +
                            '</header>' +
                            '<body>' +
                            '<command>get.system.login</command>' +
                            '<content></content>' +
                            '</body>' +
                            '</envelope>';
                        var states = ocx.IGetCGI("http://127.0.0.1:" + po + "/tdkcgi", content);
                        if (states === 'error'){
                            var status = ocx.IGetCGI("https://127.0.0.1:" + po + "/tdkcgi", content);
                            if(status === 'error'){
                                var pos=ocx.ICloudAddMapPort(id, 1, 0)-0;
                                if(pos>0){
                                    window.open('./webClient.html?'+id+'&'+this.pwd.user+'&'+this.pwd.pwd+'&'+localStorage.getItem('lan'));
                                    this.$emit("loadMsg",false);
                                    return false;
                                };
                                this.$emit("loadMsg",false);
                                alert(this.lanNow.lan['K174_Fail']);
                                return false;
                            }else {
                                this.pro = 'https';
                            };
                        };
                        this.$emit("loadMsg",false);
                        var deviceUserName=this.pwd.user;
                        var baseFun=this.base64;
                        var base=new baseFun();
                        var user=base.encode(deviceUserName);
                        var pw=base.encode(this.pwd.pwd);
                        var sh=isShare-0?1:0;
                        var url = this.pro+"127.0.0.1:" + po + "/main.html" + "?" + po + "&" + id +
                            "&" + user + "&" + pw + "&" + localStorage.getItem('lan')+'&'+name+'&'+sh;
                        window.open(url);
                        return false;
                    };
                    if(ocx.IGetSupportP2P()-0){
                        this.pro='http://';
                        var port=ocx.ICloudAddMapPortEx(id,2);
                        if(port-0===0){
                            port=ocx.ICloudAddMapPortEx(id,1);
                            this.pro='https://';
                        }else{
                            var content = '<?xml version="1.0" encoding="utf-8"?>' +
                            '<envelope>' +
                            '<header>' +
                            '<security>username</security>' +
                            '<username>adminapp</username>' +
                            '<password>' +this.pwd+ '</password>' +
                            '</header>' +
                            '<body>' +
                            '<command>get.system.login</command>' +
                            '<content></content>' +
                            '</body>' +
                            '</envelope>';
                            var states = ocx.IGetCGI("http://127.0.0.1:" + port + "/tdkcgi", content);
                            if (states === 'error'){
                                port=ocx.ICloudAddMapPortEx(id,1);
                                this.pro='https://';
                            }else{
                                states=$.parseXML(states);
                                if($(states).find('error').text()==='0'){
                                    content = '<?xml version="1.0" encoding="utf-8"?>' +
                                    '<envelope>' +
                                    '<header>' +
                                    '<security>username</security>' +
                                    '<username>adminapp</username>' +
                                    '<password>' +this.pwd+ '</password>' +
                                    '</header>' +
                                    '<body>' +
                                    '<command>get.network.https.certificate.status</command>' +
                                    '<content></content>' +
                                    '</body>' +
                                    '</envelope>';
                                    var https = ocx.IGetCGI("http://127.0.0.1:" + port + "/tdkcgi", content);
                                    if (https === 'error'){
                                        port=ocx.ICloudAddMapPortEx(id,1);
                                        this.pro='https://';
                                    }else{
                                        https=$.parseXML(https);
                                        if($(https).find('error').text()==='0'){
                                            var enable=$(https).find('enable').text()==='true';
                                            if(enable){
                                                port=ocx.ICloudAddMapPortEx(id,1);
                                                this.pro='https://';
                                            };
                                        }else{
                                            port=ocx.ICloudAddMapPortEx(id,1);
                                            this.pro='https://';
                                        };
                                    };
                                }else if($(states).find('error').text()==='-3'||$(states).find('error').text()==='-4'){
                                    alert(this.lanNow.lan['K171_Error']);
                                    return false;
                                }else{
                                    port=ocx.ICloudAddMapPortEx(id,1);
                                    this.pro='https://';
                                };
                            };
                        };
                        this.$emit("loadMsg",false);
                        if(port-0===0){
                            alert(this.lanNow.lan['K174_Fail']);
                            this.$emit('refresh');
                        }else{
                            var deviceUserName='adminapp';
                            var baseFun=this.base64;
                            var base=new baseFun();
                            var user=base.encode(deviceUserName);
                            var pw=base.encode(this.pwd);
                            var encodeKey=base.encode(this.encodeKey);
                            var sh=isShare-0?1:0;
                            var url = this.pro+"127.0.0.1:" + port + "/main.html" + "?" + port + "&" + id +
                                "&" + user + "&" + pw + "&" + localStorage.getItem('lan')+'&'+name+'&'+sh+'&'+encodeKey+'&0';
                            window.open(url);
                        };
                    }else{
                        this.$emit("loadMsg",false);
                    };
                }.bind(this),3000);
                
            // });
        },
        cf_MyDeviceP2P:function(port){
            if(port-0 === 0 && this.pro === 'http://'){
                this.socket.set.send(this.jsonStr(116,[this.wkAs.id,1,'1']));//非IE浏览器端口穿透
                this.pro='https://';
                return false;
            }else if(port-0 !== 0 && this.pro === 'http://'){
                var content = '<?xml version="1.0" encoding="utf-8"?>' +
                '<envelope>' +
                '<header>' +
                '<security>username</security>' +
                '<username>adminapp</username>' +
                '<password>' +this.pwd+ '</password>' +
                '</header>' +
                '<body>' +
                '<command>get.system.login</command>' +
                '<content></content>' +
                '</body>' +
                '</envelope>';
                this.IPPort=port-0;
                this.contP=content;
                this.socketObj.set[133]=function(res){
                    this.cf_MyDeviceP2Ps(res[0]);
                }.bind(this);
                this.socket.set.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + port + "/tdkcgi",content]));
                return false;
            };
            this.cf_CloudidP2PJump(port);
        },
        cf_MyDeviceP2Ps:function(status){
            if (status === 'error'&&this.pro==='http://'){
                this.socket.set.send(this.jsonStr(116,[this.wkAs.id,1,'1']));//非IE浏览器端口穿透
                this.pro='https://';
                return false;
            }else if (status !== 'error'&&this.pro==='http://'){
                if(this.httpsTest===false){
                    if($($.parseXML(status)).find('error').text()==='0'){
                        var content = '<?xml version="1.0" encoding="utf-8"?>' +
                        '<envelope>' +
                        '<header>' +
                        '<security>username</security>' +
                        '<username>adminapp</username>' +
                        '<password>' +this.pwd+ '</password>' +
                        '</header>' +
                        '<body>' +
                        '<command>get.network.https.certificate.status</command>' +
                        '<content></content>' +
                        '</body>' +
                        '</envelope>';
                        this.contP=content;
                        this.socketObj.set[133]=function(res){
                            this.cf_MyDeviceP2Ps(res[0]);
                        }.bind(this);
                        this.httpsTest=true;
                        this.socket.set.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + this.IPPort + "/tdkcgi",content]));
                    }else if($($.parseXML(status)).find('error').text()==='-3'||$($.parseXML(status)).find('error').text()==='-4'){
                        alert(this.lanNow.lan['K171_Error']);
                    }else{
                        this.socket.set.send(this.jsonStr(116,[this.wkAs.id,1,'1']));//非IE浏览器端口穿透
                        this.pro='https://';
                    };
                }else{
                    this.httpsTest=false;
                    var https=$.parseXML(status);
                    if($(https).find('error').text()==='0'){
                        var enable=$(https).find('enable').text()==='true';
                        if(enable){
                            this.socket.set.send(this.jsonStr(116,[this.wkAs.id,1,'1']));//非IE浏览器端口穿透
                            this.pro='https://';
                        }else{
                            this.cf_CloudidP2PJump(this.IPPort);
                        };
                    }else if($(https).find('error').text()==='-3'||$(https).find('error').text()==='-4'){
                        alert(this.lanNow.lan['K171_Error']);
                    }else{
                        this.socket.set.send(this.jsonStr(116,[this.wkAs.id,1,'1']));//非IE浏览器端口穿透
                        this.pro='https://';
                    };
                };
                return false;
            };
        },
        cf_CloudidP2PJump:function(port){
            this.$emit("loadMsg",false);
            if(port-0===0){
                alert(this.lanNow.lan['K174_Fail']);
                this.$emit('refresh');
            }else{
                var deviceUserName='adminapp';
                var baseFun=this.base64;
                var base=new baseFun();
                var user=base.encode(deviceUserName);
                var pwd=base.encode(this.wkAs.pwd);
                var encodeKey=base.encode(this.wkAs.encodeKey);
                var sh=this.wkAs.share-0?1:0;
                var url = this.pro+"127.0.0.1:" + port + "/main.html" + "?" + port + "&" + this.wkAs.id +
                    "&" + user + "&" + pwd + "&" + localStorage.getItem('lan')+'&'+this.wkAs.name+'&'+sh+'&'+encodeKey+'&0';
                window.open(url);
            };
        },
        cf_MyDeviceP2PHs:function(port){
            if (port-0 <= 0){
                alert(this.lanNow.lan['K174_Fail']);
                this.$emit("loadMsg",false);
                this.$emit('refresh');
                return false;
            };
            var content = '<?xml version="1.0" encoding="utf-8"?>' +
                '<envelope>' +
                '<header>' +
                '<security>username</security>' +
                '<username>' +JSON.parse(this.wkAs.pwd).user+ '</username>' +
                '<password>' +JSON.parse(this.wkAs.pwd).pwd+ '</password>' +
                '</header>' +
                '<body>' +
                '<command>get.system.login</command>' +
                '<content></content>' +
                '</body>' +
                '</envelope>';
            this.IPPort=port-0;
            this.contP=content;
            this.socketObj.set[133]=function(res){
                this.cf_MyDeviceP2PHsC(res[0]);
            }.bind(this);
            this.socket.set.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + port + "/tdkcgi",content]));
        },
        cf_MyDeviceP2PHsC:function(status){
            if (status === 'error'&&this.pro==='http://'){
                this.pro='https://';
                this.socket.set.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + this.IPPort + "/tdkcgi",this.contP]));
            }else if(status === 'error'&&this.pro==='https://'){
                this.$emit("loadMsg",false);
            }else{
                this.$emit("loadMsg",false);
                var deviceUserName=JSON.parse(this.wkAs.pwd).user;
                var baseFun=this.base64;
                var base=new baseFun();
                var user=base.encode(deviceUserName);
                var pwd=base.encode(JSON.parse(this.wkAs.pwd).pwd);
                var sh=this.wkAs.share-0?1:0;
                var url = this.pro+"127.0.0.1:" + this.IPPort + "/main.html" + "?" + this.IPPort + "&" + this.wkAs.id +
                    "&" + user + "&" + pwd + "&" + localStorage.getItem('lan')+'&'+this.wkAs.name+'&'+sh;
                window.open(url);
            };
        },
        getPage:function(data){
            this.nowPage=data-0;
            this.setList=this.myDevice[this.nowPage-1];
        },
        lang:function(){
            this.mCText=this.lanNow.lan['K029_MyDevice'];
            this.ShareDevice=this.lanNow.lan['K163_Share'];
            this.title=[
                // {text:this.lanNow.lan['K023_DeviceName'],class:'title-2'},
                // {text:this.lanNow.lan['K004_CloudID'],class:'title-3'},
                // {text:this.lanNow.lan['K030_DeviceType'],class:'title-2'},
                // {text:this.lanNow.lan['K031_DeviceIP'],class:'title-3'},

                //{text:this.lanNow.lan['K023_DeviceName'],class:'title-6'},
                //{text:this.lanNow.lan['K004_CloudID'],class:'title-6'},
                //{text:this.lanNow.lan['K030_DeviceType'],class:'title-2'},
                //{text:this.lanNow.lan['K031_DeviceIP'],class:'title-6'},

                {text:this.lanNow.lan['K023_DeviceName'],class:'title-6'},
                {text:this.lanNow.lan['K004_CloudID'],class:'title-6'},
                {text:this.lanNow.lan['K030_DeviceType'],class:'title-2'},
                {text:this.lanNow.lan['K031_DeviceIP'],class:'title-6'},

                {text:this.lanNow.lan['K033_Status'],class:'title-1'},
                {text:this.lanNow.lan['K036_DeviceAccess'],class:'title-1'},
                {text:this.lanNow.lan['K035_ModifyDevice'],class:'title-1'},
                {text:this.lanNow.lan['K034_ShareDevice'],class:'title-1'},
                {text:this.lanNow.lan['K037_Delete'],class:'title-1'},
            ];
        }
    },
    watch:{
        myDevice:function(){
            var arr=JSON.parse(JSON.stringify(this.myDevice));
            if(this.nowPage>arr.length&&arr.length>=1){
                this.setList=arr[arr.length-1];
                this.nowPage=arr.length;
            }else{
                this.setList=arr[this.nowPage-1];
            };
            this.allPage=arr.length;
        },
    }
}
</script>
<style scoped>
    #myCloud{
        width:100%;
        /* height:230px; */
    }
    #mcTitle{
        font-size:14px;
        font-weight: bold;
        color:#229EF1;
        padding-left:10px;
        box-sizing: border-box;
    }
    #mcTable{
        width:100%;
    }
    #mcTable ul{
        width:100%;
        height:24px;
    }
    #mcTable ul li{
        height:24px;
        font-size:12px;
        line-height:24px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
    #mcTable ul li+li{
        border-left:1px solid #BFC7D2;
    }
    #mcTable ul:nth-child(n+1) li{
        border-top:1px solid #BFC7D2;
    }
    #mcTable ul li button{
        width:60px;
        height:20px;
        line-height: 18px;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
    #mcTh{
        background-color: #7F8B9B;
    }
    #mcTh li{
        color:#fff;
        font-weight: bold;
    }
    #mcTable ul+ul{
        background-color: #FFFFFF;
    }
    #mcTable ul+ul li{
        color:#000;
    }
    .title-1{
        width:12%;
    }
    .title-2{
        width:18%;
    }
    .title-3{
        width:12%;
    }
    .title-4{
        width:16%;
    }
    .title-5{
        width:18%;
    }
    .title-6{
        width:20%;
    }
</style>
<style scoped>
    @import '../assets/css/tabList.css';  
</style>





// WEBPACK FOOTER //
// src/components/MyDevice.vue